import React from "react";
import { makeStyles } from "@material-ui/styles";
import { Container, Grid } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import LevelUpComp from "../components/LevelUp";

const useStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.down("sm")]: {
      paddingTop: theme.spacing(3)
    },
    paddingBottom: theme.spacing(3),
    background: theme.palette.primary.light,
    width: "100%"
  },
  grid: {
    marginTop: theme.spacing(2)
  },
  title: {
    color: theme.palette.text.primary
  }
}));

function LevelUp() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Container maxWidth={true}>
        <Typography variant="h1" className={classes.title}>
          Level Up!
        </Typography>

        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12}>
            <LevelUpComp></LevelUpComp>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

export default LevelUp;
